import { render, staticRenderFns } from "./TarotOrder.vue?vue&type=template&id=41f6371c&scoped=true&"
import script from "./TarotOrder.vue?vue&type=script&lang=js&"
export * from "./TarotOrder.vue?vue&type=script&lang=js&"
import style0 from "./TarotOrder.vue?vue&type=style&index=0&id=41f6371c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f6371c",
  null
  
)

export default component.exports